import React, { useState, useEffect } from "react";
import { JobCard } from "./JobsList";

export default function TrendingAndExpiringJobs() {
  const [activeTab, setActiveTab] = useState("trending");
  const [trendingJobs, setTrendingJobs] = useState([]);
  const [expiringJobs, setExpiringJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;
    
    Promise.all([
      axios.get(constvar.api_url + "jobs?per_page=8", { signal }),
      axios.get(constvar.api_url + "jobs?per_page=8&sort=expiring", { signal }),
    ])
      .then(([trendRes, expRes]) => {
        if (!isMounted) return;
        if (trendRes.data.status === "success")
          setTrendingJobs(trendRes.data.data.data || []);
        if (expRes.data.status === "success")
          setExpiringJobs(expRes.data.data.data || []);
      })
      .catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load jobs:", error);
        }
      })
      .finally(() => setLoading(false));

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const currentJobs = activeTab === "trending" ? trendingJobs : expiringJobs;

  if (!loading && trendingJobs.length === 0 && expiringJobs.length === 0)
    return null;

  return (
    <section className="sf-section">
      <div className="sf-container">
        <div className="sf-training-tabs">
          <div
            className={"sf-tab" + (activeTab === "trending" ? " active" : "")}
            onClick={() => setActiveTab("trending")}
          >
            Trending Jobs
          </div>
          <div
            className={"sf-tab" + (activeTab === "expiring" ? " active" : "")}
            onClick={() => setActiveTab("expiring")}
          >
            Expiring Soon
          </div>
        </div>

        {loading ? (
          <div className="sf-loading">
            <i className="fa fa-spinner fa-spin" /> Loading…
          </div>
        ) : currentJobs.length > 0 ? (
          <div className="sf-jobs-grid">
            {currentJobs.map((job) => (
              <JobCard key={job.id} job={job} />
            ))}
          </div>
        ) : (
          <div className="sf-empty">No jobs in this category.</div>
        )}
      </div>
    </section>
  );
}
